export class Article
{
	articleId: number;
	articleDate: Date;
	pageStartDate: Date;
	pageEndDate: Date;
	pageTitle: string;
	linkDescription: string; 
	pageHtml: string;
	pageText: string;
	enteredByUserId: number;

}
